import { NextSeo } from 'next-seo';
import TheKittiesPage from '../../components/TheKittiesPage';

export default function SecondLitterPage() {
  const title = 'Fourth Litter - Shitty Kitties';
  const description = `Fourth Litter is a collection of 2,405 shitty, hand-drawn NFT kitties on the Algorand blockchain and is the final Litter in the Shitty Kitties family.`;

  return (
    <div>
      <NextSeo title={title} description={description} />
      <TheKittiesPage title={'Fourth Litter'} gen={4} />
    </div>
  );
}
